import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from '@sg/garnish';

export const DeliveryPreferencesFormSubmitButton = (
  props: SubmitButtonProps,
) => {
  const { isSubmitting, submitForm } = props;
  const { formatMessage } = useIntl();

  return (
    <Button
      size="large"
      width="100%"
      onPress={submitForm}
      isLoading={isSubmitting}
      testID="delivery.preferences.save-button"
      accessibilityLabel={formatMessage(messages.deliveryPreferencesSaveA11y)}
      accessibilityHint={formatMessage(messages.deliveryPreferencesSaveA11y)}
      accessibilityRole="button"
    >
      {formatMessage(messages.deliveryPreferencesSave)}
    </Button>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  deliveryPreferencesSaveA11y: {
    defaultMessage: 'Save Delivery Preferences',
    description: 'Delivery | Preferences | Save | A11y',
  },
  deliveryPreferencesSave: {
    defaultMessage: 'Save',
    description: 'Delivery | Preferences | Save',
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type SubmitButtonProps = Readonly<{
  isSubmitting?: boolean;
  submitForm: () => void;
}>;
